import React from "react";
import MapComp from "../../components/MapComp";
import SearchPageComp from "../../components/SearchPageComp";
import SearchFilterComp from "../../components/SearchFilterComp";
// import SignupPopup from "../../components/PopupComp/SignupPopup";
import { LoadingComp } from "../../components/LoadingComp";

import { connect } from "react-redux";
import { getListing } from "../../store/actions/searchActions";
import { getCurrencyList } from "../../store/actions/currencyActions";
import { getAmenitiesList } from "../../store/actions/amenitiesActions";
import "./style.scss";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.params = new URLSearchParams(this.props.location.search);

    this.state = {
      listing: []
    };
  }

  componentDidMount() {
    this.listingData(1);
    this.props.getCurrencyList();
    this.props.getAmenitiesList();
  }

  listingData = (setPage = 2) => {
    let page = this.params.get("page") ? this.params.get("page") : 1;
    let purpose = this.params.get("purpose") ? this.params.get("purpose") : 0;
    let price = this.params.get("price") ? this.params.get("price") : null;
    let sort = this.params.get("sort") ? this.params.get("sort") : "All";
    let sortby = this.params.get("sortby")
      ? this.params.get("sortby")
      : "Popular";
    let amenities = this.params.get("amenities")
      ? this.params.get("amenities")
      : [];
    let attendees = this.params.get("attendees")
      ? this.params.get("attendees")
      : null;

    let search = this.props.location.pathname.split("/")[2];

    let cur_value = localStorage.getItem("O_Auth")
      ? JSON.parse(localStorage.getItem("O_Auth"))["currency"]
      : 1;

    let map = this.params.get("map") ? true : false;
    if (window.innerWidth <= 767) {
      map = true;
    }

    if (setPage === 1 && !map) {
      this.params.delete("page");
      this.props.history.push({
        search: this.params.toString()
      });
      page = 1;
    }
    setTimeout(
      this.props.getListing(
        page,
        search,
        price,
        sort,
        sortby,
        amenities,
        attendees,
        cur_value,
        purpose,
        map
      ),
      50
    );
  };

  // Set Filter params in url
  setParamsInUrl = (param, value) => {
    this.params.set(param, value);

    this.props.history.push({
      search: this.params.toString()
    });

    setTimeout(() => this.listingData(), 100);
  };

  // remove Filter params in url
  removeParamsInUrl = param => {
    this.params.delete(param);

    this.props.history.push({
      search: this.params.toString()
    });
    setTimeout(() => this.listingData(), 50);
  };

  //---------------- MapComp & SearchComp ----------------//

  onChildClickCallback = (key, listAutoScroll) => {
    let { listing } = this.props;

    const index = listing.findIndex(e => e.id === parseInt(key));

    this.onCenterPosition(
      listing[index].location.lat,
      listing[index].location.lng
    );

    this.setState(state => {
      listing.forEach(result => {
        result.show = false; // eslint-disable-line no-param-reassign
      });

      listing[index].show = !listing[index].show; // eslint-disable-line no-param-reassign

      return { listing: listing };
    });

    if (listAutoScroll) {
      this.refs.SearchPageComp.handleClick(key);
    }
  };

  //---------------- MapComp ----------------//

  onCenterPosition = (lat, lng) => {
    this.setState({
      center: {
        lat: lat,
        lng: lng
      }
    });
  };

  priceOnly = price => {
    let cur_value = this.props.singleCurrency.value;

    return (price /= cur_value).toFixed(2);
  };

  codeOnly = () => {
    let cur_code = this.props.singleCurrency.code;

    if (cur_code === "INR") {
      cur_code = "₹";
    }

    if (cur_code === "EUR") {
      cur_code = "€";
    }

    return cur_code;
  };

  priceCalculation = price => {
    return this.codeOnly() + " " + this.priceOnly(price);
  };

  render() {
    let {
      listing,
      isLoading,
      isListLoading,
      max_price,
      max_attendees,
      total_count,
      currency,
      amenities
    } = this.props;

    let page = this.params.get("page") ? parseInt(this.params.get("page")) : 1;
    let map = this.params.get("map") ? true : false;

    return (
      <div>
        {/* <SignupPopup /> */}

        {!isLoading ? (
          <SearchFilterComp
            setParamsInUrl={this.setParamsInUrl}
            removeParamsInUrl={this.removeParamsInUrl}
            urlPath={this.props}
            searchPath={this.props.location.search}
            maxValue={Math.ceil(this.priceOnly(max_price))}
            maxValueAttendees={max_attendees}
            currency={currency}
            codeOnly={this.codeOnly}
            amenities={amenities}
          />
        ) : (
          ""
        )}

        {!isLoading ? (
          listing.length > 0 ? (
            <div
              className={`search_block ${
                !this.params.get("map") ? "no_map" : "map"
              }`}
            >
              <SearchPageComp
                ref="SearchPageComp"
                listing={listing}
                onChildClickCallback={this.onChildClickCallback}
                onCenterPosition={this.onCenterPosition}
                page={page}
                map={map}
                setParamsInUrl={this.setParamsInUrl}
                total_count={total_count}
                priceCalculation={this.priceCalculation}
                listingData={this.listingData}
                isListLoading={isListLoading}
              />

              {!map && isListLoading ? (
                <LoadingComp customStyle={{ padding: 0 }} />
              ) : null}

              {map ? (
                <div className="search_map">
                  <MapComp
                    listing={listing}
                    onChildClickCallback={this.onChildClickCallback}
                    priceCalculation={this.priceCalculation}
                    center={this.state.center}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className="no_result">
              No workspaces in your specific searched location
            </div>
          )
        ) : (
          <div className="skeleton">
            <div className="container">
              <div className="post">
                <div className="avatar"></div>
                <div className="line"></div>
                <div className="line"></div>
              </div>

              <div className="post">
                <div className="avatar"></div>
                <div className="line"></div>
                <div className="line"></div>
              </div>
            </div>
            <div className="map__"></div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    listing: state.listing.list,
    max_price: state.listing.max_price,
    max_attendees: 500,
    total_count: state.listing.total_count,
    isLoading: state.listing.isLoading,
    isListLoading: state.listing.isListLoading,
    currency: state.currency.data,
    amenities: state.amenities.data,
    singleCurrency: state.singleCurrency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getListing: (
      page,
      search,
      price,
      sort,
      sortby,
      amenities,
      attendees,
      cur_value,
      purpose,
      map
    ) =>
      dispatch(
        getListing(
          page,
          search,
          price,
          sort,
          sortby,
          amenities,
          attendees,
          cur_value,
          purpose,
          map
        )
      ),
    getCurrencyList: () => dispatch(getCurrencyList()),
    getAmenitiesList: () => dispatch(getAmenitiesList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
